<script>
export default {
  methods: {
    $can(permissionName) {
      //  console.log('abc',Permissions,permissionName);
      // return Permissions.indexOf(permissionName) !== -1;
      return Permissions.findIndex(element => element.indexOf(permissionName) == 0) !== -1;
    },
  },
};
</script>
